export const quizzes = [
  {
    id: 1,
    wordpressId: 1, // WordPress post ID - update this to match your actual WordPress quiz post IDs
    title: 'نبض فيجماوية',
    description: 'قم ببناء خريطة مهاراتك واحصل على توصيات تعليمية مخصصة وقارن قدراتك مع الآخرين',
    icon: 'bi-grid-3x3-gap-fill',
    duration: 25,
    questions: 25,
    participants: 64511,
    points: 750,
    category: 'مهارات',
    topics: ['UX', 'إدارة المنتج'],
    difficulty: 'متوسط',
    timeLimit: 25,
    attempts: 5,
    attemptsPeriod: 7, // days
    language: 'العربية',
    isPopular: true,
    isAdaptive: true,
    instructions: [
      'الاختبار له حد زمني محدد',
      'لا تستخدم محركات البحث أو أي مصادر خارجية',
      'بمجرد إرسال الإجابة، لا يمكنك العودة إليها',
      // 'إذا كنت غير متأكد، يمكنك اختيار "لا أعرف"',
      'يمكنك الخروج من الاختبار في أي وقت',
      'لديك 5 محاولات كل 7 أيام'
    ],
    bestFor: 'المصممين والمطورين ومديري المنتجات والمهتمين بتصميم تجربة المستخدم على جميع المستويات',
    details: [
      { icon: 'bi-database', text: 'أكثر من 2000 سؤال معتمد' },
      { icon: 'bi-graph-up', text: 'تحليلات معيارية للصناعة' },
      { icon: 'bi-file-earmark-text', text: 'تقرير شامل للمهارات' },
      { icon: 'bi-translate', text: 'اللغة العربية' },
      { icon: 'bi-cpu', text: 'محرك اختبار تكيفي' },
      { icon: 'bi-clock', text: 'أكمل في وقتك الخاص' },
      { icon: 'bi-lightbulb', text: 'احصل على توصيات تعليمية' }
    ]
  },
  {
    id: 2,
    wordpressId: 2, // WordPress post ID - update this to match your actual WordPress quiz post IDs
    title: 'Figma',
    description: 'اختبر معرفتك بكيفية مساعدة Figma للفرق على العصف الذهني والتعاون والبناء والاختبار معاً',
    icon: 'bi-palette-fill',
    duration: 25,
    questions: 25,
    participants: 24734,
    points: 500,
    category: 'أدوات',
    topics: ['Figma', 'تصميم'],
    difficulty: 'متوسط',
    timeLimit: 25,
    attempts: 3,
    attemptsPeriod: 7,
    language: 'العربية',
    isPopular: true,
    isAdaptive: false,
    instructions: [
      'الاختبار له حد زمني محدد',
      'لا تستخدم محركات البحث أو أي مصادر خارجية',
      'بمجرد إرسال الإجابة، لا يمكنك العودة إليها'
    ],
    bestFor: 'المصممين الذين يستخدمون Figma في عملهم اليومي',
    details: [
      { icon: 'bi-file-earmark-text', text: 'تقرير شامل للمهارات' },
      { icon: 'bi-translate', text: 'اللغة العربية' },
      { icon: 'bi-clock', text: 'أكمل في وقتك الخاص' }
    ]
  },
  {
    id: 3,
    wordpressId: 3, // WordPress post ID - update this to match your actual WordPress quiz post IDs
    title: 'الانتباه للتفاصيل',
    description: 'أظهر عينك للتفاصيل وانظر كيف تقارن نفسك مع المصممين حول العالم',
    icon: 'bi-eye-fill',
    duration: 25,
    questions: 25,
    participants: 12290,
    points: 400,
    category: 'مهارات',
    topics: ['UX', 'تصميم'],
    difficulty: 'صعب',
    timeLimit: 25,
    attempts: 3,
    attemptsPeriod: 7,
    language: 'العربية',
    isPopular: true,
    isAdaptive: false,
    instructions: [
      'الاختبار له حد زمني محدد',
      'ركز على التفاصيل الدقيقة في كل سؤال',
      'بمجرد إرسال الإجابة، لا يمكنك العودة إليها'
    ],
    bestFor: 'المصممين الذين يريدون تحسين دقتهم واهتمامهم بالتفاصيل',
    details: [
      { icon: 'bi-file-earmark-text', text: 'تقرير شامل للمهارات' },
      { icon: 'bi-translate', text: 'اللغة العربية' }
    ]
  },
  {
    id: 4,
    wordpressId: 4, // WordPress post ID - update this to match your actual WordPress quiz post IDs
    title: 'إمكانية الوصول',
    description: 'قيم فهمك لإمكانية الوصول وانظر كيف تقارن نفسك مع المصممين حول العالم',
    icon: 'bi-person-check-fill',
    duration: 25,
    questions: 25,
    participants: 11541,
    points: 450,
    category: 'مهارات',
    topics: ['UX', 'إمكانية الوصول'],
    difficulty: 'متوسط',
    timeLimit: 25,
    attempts: 3,
    attemptsPeriod: 7,
    language: 'العربية',
    isPopular: false,
    isAdaptive: false,
    instructions: [
      'الاختبار له حد زمني محدد',
      'ركز على مبادئ إمكانية الوصول',
      'بمجرد إرسال الإجابة، لا يمكنك العودة إليها'
    ],
    bestFor: 'المصممين الذين يريدون فهم مبادئ إمكانية الوصول',
    details: [
      { icon: 'bi-file-earmark-text', text: 'تقرير شامل للمهارات' },
      { icon: 'bi-translate', text: 'اللغة العربية' }
    ]
  },
  {
    id: 5,
    wordpressId: 5, // WordPress post ID - update this to match your actual WordPress quiz post IDs
    title: 'مبادئ التصميم',
    description: 'اختبر معرفتك بالمبادئ الأساسية للتصميم الجرافيكي والتصميم الرقمي',
    icon: 'bi-brush-fill',
    duration: 20,
    questions: 20,
    participants: 8934,
    points: 350,
    category: 'مهارات',
    topics: ['تصميم', 'مبادئ'],
    difficulty: 'سهل',
    timeLimit: 20,
    attempts: 5,
    attemptsPeriod: 7,
    language: 'العربية',
    isPopular: false,
    isAdaptive: false,
    instructions: [
      'الاختبار له حد زمني محدد',
      'ركز على المبادئ الأساسية',
      'بمجرد إرسال الإجابة، لا يمكنك العودة إليها'
    ],
    bestFor: 'المبتدئين في التصميم والمهتمين بتعلم المبادئ الأساسية',
    details: [
      { icon: 'bi-file-earmark-text', text: 'تقرير شامل للمهارات' },
      { icon: 'bi-translate', text: 'اللغة العربية' }
    ]
  },
  {
    id: 6,
    wordpressId: 6, // WordPress post ID - update this to match your actual WordPress quiz post IDs
    title: 'التصميم المتجاوب',
    description: 'اختبر معرفتك بتصميم واجهات متجاوبة تعمل على جميع الأجهزة',
    icon: 'bi-phone-fill',
    duration: 30,
    questions: 30,
    participants: 15678,
    points: 600,
    category: 'مهارات',
    topics: ['UX', 'تصميم متجاوب'],
    difficulty: 'متوسط',
    timeLimit: 30,
    attempts: 3,
    attemptsPeriod: 7,
    language: 'العربية',
    isPopular: false,
    isAdaptive: false,
    instructions: [
      'الاختبار له حد زمني محدد',
      'ركز على مبادئ التصميم المتجاوب',
      'بمجرد إرسال الإجابة، لا يمكنك العودة إليها'
    ],
    bestFor: 'المصممين والمطورين الذين يعملون على واجهات متجاوبة',
    details: [
      { icon: 'bi-file-earmark-text', text: 'تقرير شامل للمهارات' },
      { icon: 'bi-translate', text: 'اللغة العربية' }
    ]
  }
];

// Sample questions for quiz 1 (نبض فيجماوية)
export const sampleQuestions = [
  {
    id: 1,
    question: 'ما هي الحد الأدنى الموصى به لعرض وارتفاع هدف اللمس بالبكسل؟',
    type: 'multiple-choice',
    image: {
      url: '/images/quiz/touch-target.png',
      alt: 'مثال على هدف اللمس'
    },
    options: [
      { id: 1, text: '44px', isCorrect: true },
      { id: 2, text: '96px', isCorrect: false },
      { id: 3, text: '10px', isCorrect: false },
      { id: 4, text: '30px', isCorrect: false }
    ],
    explanation: 'الحد الأدنى الموصى به لهدف اللمس هو 44x44 بكسل لضمان سهولة الاستخدام على الشاشات اللمسية'
  },
  {
    id: 2,
    question: 'ما هو الفرق بين UX و UI؟',
    type: 'multiple-choice',
    options: [
      { id: 1, text: 'UX يركز على التجربة بينما UI يركز على المظهر', isCorrect: true },
      { id: 2, text: 'لا يوجد فرق، هما نفس الشيء', isCorrect: false },
      { id: 3, text: 'UX للموبايل و UI للويب', isCorrect: false },
      { id: 4, text: 'UX للتصميم و UI للبرمجة', isCorrect: false }
    ],
    explanation: 'UX (تجربة المستخدم) يركز على التجربة الشاملة والوظائف، بينما UI (واجهة المستخدم) يركز على المظهر البصري'
  },
  {
    id: 3,
    question: 'ما هي أفضل ممارسة لاستخدام الألوان في التصميم؟',
    type: 'multiple-choice',
    options: [
      { id: 1, text: 'استخدام أكبر عدد ممكن من الألوان', isCorrect: false },
      { id: 2, text: 'استخدام لوحة ألوان محدودة ومتسقة', isCorrect: true },
      { id: 3, text: 'استخدام ألوان عشوائية', isCorrect: false },
      { id: 4, text: 'عدم استخدام الألوان نهائياً', isCorrect: false }
    ],
    explanation: 'استخدام لوحة ألوان محدودة ومتسقة يساعد في إنشاء تصميم متناسق وسهل الاستخدام'
  }
];
